import {jwtServerInstance} from "../index";
import qs from	'qs'

//参数配置列表查询接口
export const queryCustomerList = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/query',
        method:'post',
        data:qs.stringify({
            customerId: queryForm.customerId,
            customerName: queryForm.customerName,
            upBusinessUser: queryForm.upBusinessUser,
            usertype: queryForm.usertype,
            userNickname: queryForm.userNickname,
            userName:queryForm.userName,
            idCardNum:queryForm.idCardNum,
            businessUser: queryForm.businessUser,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//参数配置列表查询接口
export const queryCustomerDetail = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/querydetail',
        method:'post',
        data:qs.stringify({
            userId: queryForm.customerId
        })
    })
}

//参数配置列表查询接口
export const getGrifterWithUserId = (customerId) => {
    return jwtServerInstance.request({
        url:'/b2cgrifter/query',
        method:'post',
        data:qs.stringify({
            userId: customerId
        })
    })
}

//参数配置列表查询接口
export const uploadToGrifter = (customerId) => {
    return jwtServerInstance.request({
        url:'/b2cgrifter/add',
        method:'post',
        data:qs.stringify({
            userId: customerId
        })
    })
}

//参数配置列表查询接口
export const getCustomerSetting = (customerId) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/setting',
        method:'post',
        data:qs.stringify({
            userId: customerId
        })
    })
}

//参数配置列表查询接口
export const updateCustomerSetting = (dialogform) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/setcustomer',
        method:'post',
        data:dialogform
    })
}

//参数配置列表查询接口
export const changeUserUsed = (userId) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/changeused',
        method:'post',
        data:qs.stringify({
            userId: userId
        })
    })
}

//参数配置列表查询接口
export const getCustomerIdCard = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/queryidcard',
        method:'post',
        data:qs.stringify({
            userName: queryForm.userName,
            realyName:queryForm.realyName,
            idCardNumber: queryForm.idCardNumber,
            upUserName:queryForm.upUserName,
            businessName: queryForm.businessName,
            status:queryForm.status,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


//参数配置列表查询接口
export const queryIdCardDetail = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/queryidcarddetail',
        method:'post',
        data:qs.stringify({
            idCardId:queryForm.idCardId
        })
    })
}

//参数配置列表查询接口
export const networkCheck = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/networkcheck',
        method:'post',
        data:qs.stringify({
            idCardId:queryForm.idCardId,
            userName:queryForm.userName,
            userNumber:queryForm.userNumber
        })
    })
}

//参数配置列表查询接口
export const changeIdcardStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/changeidcardstatus',
        method:'post',
        data:qs.stringify({
            idCardId:queryForm.idCardId,
            status:queryForm.status,
            because: queryForm.because
        })
    })
}

//参数配置列表查询接口
export const addOrChangeIdCardRemarks = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/addremarks',
        method:'post',
        data:qs.stringify({
            idCardId:queryForm.idCardId,
            remarks:queryForm.remarks
        })
    })
}

//参数配置列表查询接口
export const changeBatchIdcardStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/batchchangeidcardstatus',
        method:'post',
        data:queryForm
    })
}


//参数配置列表查询接口
export const queryplateformList = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/queryplateformlist',
        method:'post',
        data:qs.stringify({
            userName: queryForm.userName,
            upBusinessUser: queryForm.upBusinessUser,
            plateformAccountName: queryForm.plateformAccountName,
            businessUser: queryForm.businessUser,
            plateformName:queryForm.plateformName,
            status:queryForm.status,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//参数配置列表查询接口
export const changeAccountUsed = (accountId) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/changeaccountused',
        method:'post',
        data:qs.stringify({
            accountId: accountId
        })
    })
}

//参数配置列表查询接口
export const deletedAccountInfo = (accountId) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/deletedaccountinfo',
        method:'post',
        data:qs.stringify({
            accountId: accountId
        })
    })
}

//参数配置列表查询接口
export const deletedBatchAccountInfo = (dataform) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/deletedaccountinfobatch',
        method:'post',
        data: dataform
    })
}

//参数配置列表查询接口
export const addOrChangeAccountRemarks = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/addaccountremarks',
        method:'post',
        data:qs.stringify({
            accountId:queryForm.accountId,
            remarks:queryForm.remarks
        })
    })
}

//参数配置列表查询接口
export const getPlateformAccountInfo = (accountId) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/accountdetail',
        method:'post',
        data:qs.stringify({
            accountId: accountId
        })
    })
}

//参数配置列表查询接口
export const changePlateformStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/changeplateformstatus',
        method:'post',
        data:qs.stringify({
            accountId:queryForm.accountId,
            status:queryForm.status,
            because: queryForm.because
        })
    })
}

//参数配置列表查询接口
export const updatePlateformSetting = (dialogform) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/setplateform',
        method:'post',
        data:dialogform
    })
}

//参数配置列表查询接口
export const changeBatchPlateformStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/batchchangePlateformstatus',
        method:'post',
        data:queryForm
    })
}


//参数配置列表查询接口
export const getCustomerMoneyList = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/querymoney',
        method:'post',
        data:qs.stringify({
            userId: queryForm.userId,
            customerName: queryForm.userName,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


//参数配置列表查询接口
export const getBusinessMoneyList = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/querybmoney',
        method:'post',
        data:qs.stringify({
            userId: queryForm.userId,
            userName: queryForm.userName,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


//参数配置列表查询接口
export const getBusinessbMoneyList = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/queryubmoney',
        method:'post',
        data:qs.stringify({
            userId: queryForm.userId,
            customerName: queryForm.userName,
            ownerWeb: queryForm.ownerWeb,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//参数配置列表查询接口
export const updateCustomerMoney = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/updateusermoney',
        method:'post',
        data:qs.stringify({
            userId: queryForm.userId,
            balanceMoney: queryForm.changeBalanceMoney,
            changeType: queryForm.isChangeConf,
            serialType: queryForm.serialType,
            cashPassword: queryForm.moneyPassword,
            remarks: queryForm.remarks
        })
    })
}


//参数配置列表查询接口
export const querycustomermdetail = (queryFrom, pagination) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/querycustomermdetail',
        method:'post',
        data:qs.stringify({
            userId: queryFrom.userId,
            orderId: queryFrom.orderId,
            taskId: queryFrom.taskId,
            userName: queryFrom.userName,
            serialTypeEnum: queryFrom.serialTypeEnum,
            accountType: queryFrom.accountType,
            startTime: queryFrom.startTime,
            endTime: queryFrom.endTime,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


//参数配置列表查询接口
export const changeOrderEnable = (dialogFrom) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/changeoenable',
        method:'post',
        data:dialogFrom
    })
}

//参数配置列表查询接口
export const changeLowerOrderEnable = (dialogFrom) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/changeloworderenable',
        method:'post',
        data:dialogFrom
    })
}

//参数配置列表查询接口
export const openCustomerShareEnable = (dialogFrom) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/opencustomershare',
        method:'post',
        data:qs.stringify({
            customerId: dialogFrom.customerId,
            enableTag: dialogFrom.enableTag
        })
    })
}


//添加或修改试客上级
export const setCustomerUpersonInfo = (dialogFrom) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/setupersoninfo',
        method:'post',
        data:qs.stringify({
            customerId: dialogFrom.customerId,
            username: dialogFrom.username,
            rolecode: dialogFrom.roleCode
        })
    })
}

//参数配置列表查询接口
export const queryAdminLoginUser = (dialogFrom) => {
    return jwtServerInstance.request({
        url:'/b2ccustomer/queryloginuser',
        method:'post',
        data:qs.stringify({
            b2cUsersId: dialogFrom.b2cUsersId
        })
    })
}

//设置试客端的提示文字
export const setCustomerTips = (dialogFrom) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/settips',
        method:'post',
        data:dialogFrom
    })
}
